import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getApiEndpoint } from "../../../utils/apiConfig";
import axiosWithAuth from "../../../utils/axiosWithAuth";
import AdminLogo from "../../../assets/images/AdminLogo.png";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosWithAuth().post(
        "auth/sign-in",
        { email, password }
      );
      if (response.data.user.role === "admin" && response.data.token) {
        const token = response.data.token;
        localStorage.setItem("authToken", token);
        localStorage.setItem("token", token);
        navigate("/dashboard");
      } else {
        alert("Bu hesap admin hesabı değil!");
        navigate("/adminlogin");
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Email veya şifre yanlış!");
      navigate("/adminlogin");
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "0.75rem",
    border: "1px solid #ddd",
    borderRadius: "0.5rem",
    fontSize: "1rem",
    outline: "none",
    transition: "border-color 0.2s",
    backgroundColor: "white",
    backgroundImage: "none !important",
    WebkitAppearance: "none",
    MozAppearance: "none",
    appearance: "none"
  };

  return (
    <div 
      style={{
        minHeight: "100vh",
        backgroundColor: "#cda742",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <div 
        style={{
          backgroundColor: "white",
          padding: "2rem",
          borderRadius: "1rem",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "100%",
          maxWidth: "400px",
          margin: "1rem"
        }}
      >
        <div 
          style={{
            textAlign: "center",
            marginBottom: "2rem"
          }}
        >
          <img
            src={AdminLogo}
            alt="Admin Logo"
            style={{
              maxWidth: "180px",
              marginBottom: "1.5rem"
            }}
          />
          <h2 
            style={{
              fontSize: "1.5rem",
              color: "#333",
              marginBottom: "0.5rem"
            }}
          >
            Admin Panel
          </h2>
        </div>

        <form onSubmit={handleLogin} autoComplete="off">
          <div 
            style={{
              marginBottom: "1rem",
              position: "relative"
            }}
          >
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={inputStyle}
              autoComplete="off"
            />
          </div>

          <div 
            style={{
              marginBottom: "1.5rem",
              position: "relative"
            }}
          >
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={inputStyle}
              autoComplete="new-password"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "1rem",
                top: "50%",
                transform: "translateY(-50%)",
                border: "none",
                background: "none",
                cursor: "pointer",
                color: "#666"
              }}
            >
              <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
            </button>
          </div>

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "0.75rem",
              backgroundColor: "#cda742",
              color: "white",
              border: "none",
              borderRadius: "0.5rem",
              fontSize: "1rem",
              cursor: "pointer",
              transition: "background-color 0.2s",
              fontWeight: "500"
            }}
          >
            Giriş
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
